import { useCallback, type Dispatch, type SetStateAction } from "react";
import type { NavigateFunction } from "react-router-dom";
import {
  computeCheckInAfterSubmitNavigation,
  type CheckInSubmitResult,
} from "../checkInSubmissionNavigation";
import type { ExistingRecord } from "../checkin-context";
import { addFeeling } from "../../../api/feelingApi";

type UseCheckInSubmissionParams = {
  existingRecord: ExistingRecord | null | undefined;
  selectedDate: string | Date | null | undefined;
  feelingName: string | null;
  causes: unknown;
  userId: string | undefined;
  organizationId: string | undefined;
  teamId: string | undefined;
  step: string;
  yourOwnCause: unknown;
  yourOwnCauseTypeId: string;
  isOffline: boolean;
  setMoods: Dispatch<SetStateAction<unknown[]>>;
  clearCache?: ((key: string) => void) | null;
  refreshTeamMoods?: (() => void) | null;
  navigate: NavigateFunction;
  setStep: (step: string) => void;
};

export function useCheckInSubmission({
  existingRecord,
  selectedDate,
  feelingName,
  causes,
  userId,
  yourOwnCause,
  yourOwnCauseTypeId,
  step,
  isOffline,
  setMoods,
  clearCache,
  refreshTeamMoods,
  navigate,
  setStep,
  teamId
}: UseCheckInSubmissionParams) {
  return useCallback(

    async (
      causeTypeId?: string
    ): Promise<CheckInSubmitResult | undefined> => {
      const navigation = computeCheckInAfterSubmitNavigation({
        existingRecord,
        isOffline,
        step,
      });

      try {

        addFeeling({
          userId,
          name: feelingName,
          causeTypeId: causeTypeId != null ? Number(causeTypeId) : undefined,
          teamId: teamId
        }).catch((error) => {
          console.error("Error creating feeling:", error);
        });





      if (navigation.nextRoute) {
        navigate(navigation.nextRoute);
      }
      if (navigation.advanceToCauseStep) {
        setStep("cause");
      }

      return {
        ok: true,
        mode: "mode",
        entry: true,
        navigation,
      };
    } catch {
      return {
        ok: false,
        mode: "modeof",
        entry: false,
        navigation,
      }; }
    },
    [
      causes,
      clearCache,
      feelingName,
      existingRecord,
      isOffline,
      navigate,
      refreshTeamMoods,
      selectedDate,
      setMoods,
      setStep,
      step,
      userId,
      yourOwnCause,
      yourOwnCauseTypeId,
    ]
  );
}
